/* unplugin-vue-components disabled */import script from "./SalesAreaTreeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesAreaTreeModal.vue?vue&type=script&setup=true&lang=js"

import "./SalesAreaTreeModal.vue?vue&type=style&index=0&id=7e6aa741&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e6aa741"]])

export default __exports__